import { useState } from 'react'
import {
  ObjectiveInput,
  DismissObjectiveInMeetingMutation,
  DismissObjectiveInMeetingMutationVariables,
  ReactiveObjectiveInMeetingMutation,
  ReactiveObjectiveInMeetingMutationVariables,
  DuplicateObjectiveInMeetingMutation,
} from '../../types'
import { client } from '../..'
import { DISMISS_OBJECTIVE_IN_MEETING, REACTIVATE_OBJECTIVE_IN_MEETING, DUPLICATE_OBJECTIVE_IN_MEETING } from './ObjectiveMutation'
import { OBJECTIVES_IN_MEETING, EXISTING_DEV_TARGETS_TO_BE_CLOSED } from './ObjectiveQuery'
import { FetchResult } from '@apollo/client'

interface Props {
  meetingId: string
  initialValue?: ObjectiveInput
}
export default ({
  meetingId,
  initialValue,
}: Props): {
  objective: ObjectiveInput | undefined
  setObjective: React.Dispatch<React.SetStateAction<ObjectiveInput | undefined>>
  dismissObjectiveApi: (objectiveId: number) => Promise<FetchResult<DismissObjectiveInMeetingMutation>>
  reactivateObjectiveApi: (objectiveId: number) => Promise<FetchResult<ReactiveObjectiveInMeetingMutation>>
  duplicateObjectiveApi: (globalId: string) => Promise<FetchResult<DuplicateObjectiveInMeetingMutation>>
} => {
  const [objective, setObjective] = useState(initialValue)

  const dismissObjectiveApi = async (objectiveId: number): Promise<FetchResult<DismissObjectiveInMeetingMutation>> => {
    return await client.mutate<DismissObjectiveInMeetingMutation, DismissObjectiveInMeetingMutationVariables>({
      mutation: DISMISS_OBJECTIVE_IN_MEETING,
      variables: {
        id: objectiveId,
        meetingId: meetingId,
      },
      refetchQueries: [
        {
          query: OBJECTIVES_IN_MEETING,
          variables: {
            meetingId,
          },
        },
        {
          query: EXISTING_DEV_TARGETS_TO_BE_CLOSED,
          variables: {
            meetingId: meetingId,
          },
        },
      ],
    })
  }

  const reactivateObjectiveApi = async (objectiveId: number): Promise<FetchResult<ReactiveObjectiveInMeetingMutation>> => {
    return await client.mutate<ReactiveObjectiveInMeetingMutation, ReactiveObjectiveInMeetingMutationVariables>({
      mutation: REACTIVATE_OBJECTIVE_IN_MEETING,
      variables: {
        id: objectiveId,
        meetingId: meetingId,
      },
      refetchQueries: [
        {
          query: OBJECTIVES_IN_MEETING,
          variables: {
            meetingId,
          },
        },
        {
          query: EXISTING_DEV_TARGETS_TO_BE_CLOSED,
          variables: {
            meetingId: meetingId,
          },
        },
      ],
    })
  }

  const duplicateObjectiveApi = async (globalId: string): Promise<FetchResult<DuplicateObjectiveInMeetingMutation>> => {
    return await client.mutate({
      mutation: DUPLICATE_OBJECTIVE_IN_MEETING,
      variables: {
        globalId,
        meetingId,
      },
      refetchQueries: [
        {
          query: OBJECTIVES_IN_MEETING,
          variables: {
            meetingId,
          },
        },
      ],
    })
  }

  return {
    objective,
    setObjective,
    dismissObjectiveApi,
    reactivateObjectiveApi,
    duplicateObjectiveApi,
  }
}
